var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareInfoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_163273",
    "data-name": "Grupo 163273",
    transform: "translate(2898.302 6094.302)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_140647",
    "data-name": "Ret\\xE2ngulo 140647",
    width: 52,
    height: 52,
    transform: "translate(-2898.302 -6094.302)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Interface-Essential_Hierarchy_Organization_hierarchy-10",
    "data-name": "Interface-Essential / Hierarchy/Organization / hierarchy-10",
    transform: "translate(-2890.102 -6084.884)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_576",
    "data-name": "Group 576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hierarchy-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval_333",
    "data-name": "Oval 333",
    d: "M282.808,5727.116a4.308,4.308,0,1,1,4.308-4.309A4.308,4.308,0,0,1,282.808,5727.116Z",
    transform: "translate(-254.086 -5718.5)",
    fill: "#2493eb",
    stroke: "#2493eb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_334",
    "data-name": "Oval 334",
    d: "M282.808,5738.616a4.308,4.308,0,1,1,4.308-4.308A4.308,4.308,0,0,1,282.808,5738.616Z",
    transform: "translate(-254.086 -5705.452)",
    fill: "#2493eb",
    stroke: "#2493eb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_335",
    "data-name": "Oval 335",
    d: "M299.808,5732.616a4.308,4.308,0,1,1,4.308-4.308A4.308,4.308,0,0,1,299.808,5732.616Z",
    transform: "translate(-295.5 -5711.793)",
    fill: "#2493eb",
    stroke: "#2493eb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2841",
    "data-name": "Shape 2841",
    d: "M300.434,5719.921l-16.088,8.8",
    transform: "translate(-275.95 -5713.572)",
    fill: "#2493eb",
    stroke: "#2493eb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2841-2",
    "data-name": "Shape 2841",
    d: "M284.346,5719.921l16.089,8.8",
    transform: "translate(-275.95 -5701.301)",
    fill: "#2493eb",
    stroke: "#2493eb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareInfoIcon);
export default __webpack_public_path__ + "static/media/share_info_icon.33057c6c.svg";
export { ForwardRef as ReactComponent };